import createExplicitLogonRequest from './createExplicitLogonRequest';
import { isConnectedAccount } from 'owa-accounts-store';
import { assertNever } from 'owa-assert';
import { MailboxInfo, MailboxType } from 'owa-client-ids';
import { getConnectedAccountRequestOptions } from 'owa-connected-account-headers';
import { getRequestOptionsOrDefault } from 'owa-headers-core';
import RequestOptions from 'owa-service/lib/RequestOptions';

export default async function getDefaultRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions | null> {
    if (mailboxInfo) {
        switch (mailboxInfo.type) {
            case MailboxType.GroupMailbox:
                return createExplicitLogonRequest(mailboxInfo.deprecatedMailboxId, mailboxInfo);
            case MailboxType.UserMailbox:
                if (isConnectedAccount(mailboxInfo.primarySmtpAddress)) {
                    return await getConnectedAccountRequestOptions(mailboxInfo);
                } else {
                    return getRequestOptionsOrDefault(mailboxInfo);
                }
            default:
                return assertNever(mailboxInfo.type);
        }
    } else {
        return null;
    }
}
